import { apiPesquisaSatisfacao } from '@/plugins/axios'

export default {
  getDadosResumidosTotal(form) {
    return apiPesquisaSatisfacao().post('/satisfacao/relatorios/resumido/total?_method=GET', form)
  },
  getDadosResumidosDiaCorrido(form) {
    return apiPesquisaSatisfacao().post('/satisfacao/relatorios/resumido/dia-corrido?_method=GET', form)
  },
  getDadosResumidosDestino(form) {
    return apiPesquisaSatisfacao().post('/satisfacao/relatorios/resumido/destino?_method=GET', form)
  },
}
